import { LazyMotion, domAnimation } from "framer-motion";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MemoryRouter } from "react-router-dom";
import { Shell } from "./components/Shell";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

/**
 * Deep links arrive as `?startapp=message_<id>` / `collection_<id>` (parsed into
 * `startParam` by bootstrapTelegram). Seed the MemoryRouter's initial entry so a
 * cold open lands directly on the target (Phase 2 gate).
 */
function startParamToPath(startParam?: string): string {
  if (!startParam) return "/";
  if (startParam.startsWith("message_")) return `/item/${startParam.slice("message_".length)}`;
  if (startParam.startsWith("collection_")) return `/collections/${startParam.slice("collection_".length)}`;
  return "/";
}

export function App({ startParam }: { startParam?: string | undefined }) {
  const initialPath = startParamToPath(startParam);
  return (
    <QueryClientProvider client={queryClient}>
      <LazyMotion features={domAnimation}>
        <MemoryRouter initialEntries={[initialPath]}>
          <Shell />
        </MemoryRouter>
      </LazyMotion>
    </QueryClientProvider>
  );
}
